import { downloadSheet, postForm, postJson } from "./http";

export interface TallyParty {
  name: string;
  gstin: string | null;
  currency_code: string | null;
  guid: string | null;
}

export interface TallyPartyIssue {
  field: string;
  message: string;
}

export interface TallyPartyImportRow {
  id: number;
  sheet_row_no: number;
  party_name: string;
  action: "new" | "unchanged" | "invalid";
  status: "pending" | "queued" | "created" | "skipped" | "failed";
  issues: TallyPartyIssue[];
  error: string | null;
  tally_ledger_guid: string | null;
}

export interface TallyPartyImport {
  id: number;
  party: "customer" | "vendor";
  filename: string | null;
  status: string;
  total_rows: number;
  new_rows: number;
  unchanged_rows: number;
  invalid_rows: number;
  created_rows: number;
  failed_rows: number;
  rows: TallyPartyImportRow[];
}

export interface TallyPartyState {
  customers: TallyParty[];
  vendors: TallyParty[];
  imports: {
    customer: TallyPartyImport | null;
    vendor: TallyPartyImport | null;
  };
}

interface DataEnvelope<T> {
  data: T;
}

const state = (publicId: string) =>
  postJson<DataEnvelope<TallyPartyState>>("/api/onboarding/tally/parties/state", { public_id: publicId }).then((r) => r.data);

const template = (publicId: string, party: "customer" | "vendor") =>
  downloadSheet(
    "/api/onboarding/tally/parties/template",
    { public_id: publicId, party },
    party === "vendor" ? "vendors.xlsx" : "customers.xlsx"
  );

const upload = async (publicId: string, party: "customer" | "vendor", file: File): Promise<TallyPartyState> => {
  const form = new FormData();
  form.append("public_id", publicId);
  form.append("party", party);
  form.append("file", file);

  return (await postForm<DataEnvelope<TallyPartyState>>("/api/onboarding/tally/parties/import/upload", form, ["file"])).data;
};

const cancel = (publicId: string, party: "customer" | "vendor") =>
  postJson<DataEnvelope<TallyPartyState>>("/api/onboarding/tally/parties/import/cancel", { public_id: publicId, party }).then((r) => r.data);

const commit = (publicId: string, party: "customer" | "vendor") =>
  postJson<DataEnvelope<TallyPartyState>>("/api/onboarding/tally/parties/import/commit", { public_id: publicId, party }).then((r) => r.data);

export const tallyPartyApi = { state, template, upload, cancel, commit };
